import { render, staticRenderFns } from "./StaffHome.vue?vue&type=template&id=27d5ad3f&"
import script from "./StaffHome.vue?vue&type=script&lang=js&"
export * from "./StaffHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports